export enum AssessmentS3DataUrl {
    COMMENTS = 'COMMENTS',
    REQUIRED_EVIDENCE = 'REQUIRED_EVIDENCE',
    SUMMARY = 'SUMMARY',
    FILE = 'FILE',
    BULK_COMMENT = 'BULK_COMMENT'
}
